import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './SectionHeader.css';


const SectionHeader = ({ className, id, label, }) => {
  return (
    <section className={cx(s.component, className)}>
      <h1 id={id} className={s.header}>{label}</h1>
      <hr className={s.underline} />
    </section>
  );
};

SectionHeader.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.node
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/FormElements/SectionHeader/SectionHeader.js